import { Dropzone as DropzoneMantine } from '@mantine/dropzone'
import type { DropzoneProps as DropzonePropsMantine } from '@mantine/dropzone'

export type DropzoneNewProps = DropzonePropsMantine

export default DropzoneMantine
